var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiltersIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings slider hor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 2.5C10.0904 2.5 9.04651 3.34961 8.75062 4.5H2.66667C2.29848 4.5 2 4.79848 2 5.16667C2 5.53486 2.29848 5.83333 2.66667 5.83333H8.75062C9.04651 6.98372 10.0904 7.83333 11.3333 7.83333C12.8065 7.83333 14 6.63986 14 5.16667C14 3.69348 12.8065 2.5 11.3333 2.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9.16667C4.75703 9.16667 3.71317 10.0163 3.41728 11.1667H2.66667C2.29848 11.1667 2 11.4651 2 11.8333C2 12.2015 2.29848 12.5 2.66667 12.5H3.41728C3.71317 13.6504 4.75703 14.5 6 14.5C7.24297 14.5 8.28683 13.6504 8.58272 12.5H13.3333C13.7015 12.5 14 12.2015 14 11.8333C14 11.4651 13.7015 11.1667 13.3333 11.1667H8.58272C8.28683 10.0163 7.24297 9.16667 6 9.16667Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersIcon);
export default __webpack_public_path__ + "static/media/filters-icon.15a664ebcd03926c05f2ec4326ffd4ef.svg";
export { ForwardRef as ReactComponent };